"use strict";

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

//sticky head
(0, _jquery2.default)(window).on("load scroll resize", function () {
  var top = (0, _jquery2.default)(window).scrollTop();
  var header = (0, _jquery2.default)(".header").outerHeight();

  if (top > header) {
    (0, _jquery2.default)(".header").addClass("header-is-fixed");
  } else {
    (0, _jquery2.default)(".header").removeClass("header-is-fixed");
  }
});

(0, _jquery2.default)(window).on("load", function () {
  var customerName = (0, _jquery2.default)(".account-dropdown__toggle").text();

  if ((0, _jquery2.default)(".mega-menu-mobile__links").hasClass("logged-in")) {
    (0, _jquery2.default)(".js-mega-menu-mobile .mega-menu-mobile__links > ul:nth-child(1)").append("<li class=\"menu__item menu__item--has-dropdown\">\n      <a class=\"menu__item menu__item--has-dropdown\" href=\"/account\">Account</a>\n      <div class=\"menu__dropdown\">\n        <div class=\"heading\">\n          <h2>\n            <a href=\"/pages/prescription-types-of-vision\">\n              <span>" + customerName + "</span>\n            </a>\n          </h2>\n        </div><!-- /.heading -->\n        <ul>\n          <li class=\"menu__item\"><a class=\"menu__item\" href=\"/account\">MY ACCOUNT</a></li>\n          <li class=\"menu__item\"><a class=\"menu__item\" href=\"/account?module=order-history\">ORDER HISTORY</a></li>\n          <li class=\"menu__item\"><a class=\"menu__item\" href=\"/pages/shipping-returns\">SHIPPING INFO</a></li>\n          <li class=\"account-dropdown_divider\"></li>\n          <li class=\"menu__item logout\"><a class=\"menu__item\" href=\"/account/logout\">LOG OUT</a></li>\n        </ul>\n      </div>\n    </li>");
  } else {
    (0, _jquery2.default)(".js-mega-menu-mobile .mega-menu-mobile__links > ul:nth-child(1)").append("<li class=\"menu__item\"><a href=\"/account\">Account</a></li>");
  }

  // Mobile navigation firt level open
  (0, _jquery2.default)(".js-mega-menu-mobile .mega-menu-mobile__links a").on("click", function (event) {
    var $this = (0, _jquery2.default)(this);
    var $parent = $this.closest(".menu__dropdown");
    var $dropdown = $this.closest("li").find("> .menu__dropdown");
    var $dropdownInner = $parent.find(".menu__dropdown");
    var $title = $this.closest(".heading").find("h1");
    var $subtitle = $parent.find("> .heading h2");
    var $subtitleBtn = $subtitle.find("a");

    var hasMenu = $this.hasClass("menu__item--has-dropdown") && !$this.parents(".menu__dropdown.open").length;
    var isUnclickable = $this.hasClass("false");

    if (hasMenu) {
      event.preventDefault();
    }

    if (hasMenu) {
      $dropdown.addClass("open");
    }

    if (isUnclickable) {
      event.preventDefault();

      $dropdownInner.removeClass("open");
    }
  });

  // Mobile navigation firt level close
  (0, _jquery2.default)(".js-mega-menu-mobile h2").on("click", function (event) {
    event.preventDefault();

    (0, _jquery2.default)(this).closest(".menu__dropdown").removeClass("open");
  });
});

// mega menu
// wrap content for mega menu
if ((0, _jquery2.default)(".js-mega-menu").length && (0, _jquery2.default)(window).width() >= 768) {
  (0, _jquery2.default)(".js-mega-menu > ul > .menu__item--has-dropdown > .menu__dropdown").each(function () {
    (0, _jquery2.default)(this).wrap('<div class="mega-menu"><div class="mega-menu__inner"></div></div>');
  });

  // show/hide navigation hover overlay
  (0, _jquery2.default)(".js-mega-menu > ul > .menu__item--has-dropdown").hover(function () {
    (0, _jquery2.default)(".global-overlay-navigation").addClass("show-overlay");
  }, function () {
    (0, _jquery2.default)(".global-overlay-navigation").removeClass("show-overlay");
  });
}

// mega menu mobile
(0, _jquery2.default)(".js-btn-burger").on("click", function (e) {
  e.preventDefault();
  (0, _jquery2.default)("body").toggleClass("open-menu");
});

// account dropdown
var openDropdown = false;
var dropdown = (0, _jquery2.default)(".account-dropdown");

(0, _jquery2.default)(".account-dropdown__toggle").on("mouseover", function () {
  dropdown.fadeIn().addClass("open");

  dropdown.on("mouseover", function () {
    dropdown.addClass("open");
    openDropdown = true;
  }).on("mouseleave", function () {
    dropdown.fadeOut().removeClass("open");
    openDropdown = false;
  });
}).on("mouseleave", function () {
  setTimeout(function () {
    if (!openDropdown && dropdown.hasClass("open")) {
      dropdown.fadeOut().removeClass("open");
    }
  }, 500);
});

// account dropdown navigating to order history
function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}

(0, _jquery2.default)(document).ready(function () {
  if ((0, _jquery2.default)("body#account").length && getQueryVariable("module") != "") {
    var module = getQueryVariable("module");

    // add class to nav list
    (0, _jquery2.default)(".Customer__sidebar-toggle").each(function () {
      if ((0, _jquery2.default)(this).data("target") === module) {
        (0, _jquery2.default)(this).addClass("active");
      } else {
        (0, _jquery2.default)(this).removeClass("active");
      }
    });

    // add class to module
    (0, _jquery2.default)(".Customer__module").each(function () {
      if ((0, _jquery2.default)(this).data("module") === module) {
        (0, _jquery2.default)(this).removeClass("hide");
      } else {
        (0, _jquery2.default)(this).addClass("hide");
      }
    });

    // change mobile title
    (0, _jquery2.default)(".js-sidebar-title").text("ORDER HISTORY");
  }
});